import React, { useState } from "react";
import {
  Container,
  Typography,
  Divider,
  Box
} from "@mui/material";
import ReleaseNotes from "./ReleaseNotes";
import styles from "./ChangeLog.module.css";
import IFrameModal from "../IFrameModal";

const ChangeLog: React.FC = () => {
  const [modalContent, setModalContent] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLinkClick = (url: string) => {
    if (url) {
      setModalContent(url);
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalContent("");
  };

  const releases = [
    {
      timePeriod: { month: "February", year: 2025 },
      versions: [
        {
          version: "2.5.26",
          description: `This version marks a significant milestone as we introduce a stable and robust trial platform designed to deliver an exceptional user experience. With a focus on reliability and ease of use, Garuda 2x is here to showcase the best of what our platform has to offer.`,
          ui: <ReleaseNotes handleLinkClick={handleLinkClick} />,
        },
      ],
    },
    {
      timePeriod: { month: "August", year: 2024 },
      versions: [
        {
          version: "2.5.15",
          description: ``,
          ui: (
            <Box>
              <Typography className={styles.descriptionText}>
                Garuda2x Release 2.5.15, the alpha release, focused on
                stabilizing the platform with:
                <ul style={{ paddingLeft: "20px", marginTop: 5 }}>
                  <li>
                    <Typography
                      className={styles.descriptionText}
                      fontWeight={500}
                    >
                      Significant enhancements across multiple components.
                    </Typography>
                  </li>
                  <li>
                    <Typography
                      className={styles.descriptionText}
                      fontWeight={500}
                    >
                      Critical bug fixes for improved reliability.
                    </Typography>
                  </li>
                </ul>
              </Typography>
              <Typography className={styles.descriptionText}>
                This version was deployed on the SBX Garuda2x server with
                accompanying installers for:
                <ul
                  style={{ paddingLeft: "20px", marginTop: 0, marginBottom: 0 }}
                >
                  <li>
                    <Typography
                      className={styles.descriptionText}
                      fontWeight={500}
                    >
                      GarudaDesktop
                    </Typography>
                  </li>
                </ul>
              </Typography>
            </Box>
          ),
        },
      ],
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h1" sx={{ fontWeight: "500" }} gutterBottom>
        Changelog : Garuda2x Updates and Changes
      </Typography>
      <Typography variant="body2" sx={{ color: "#939191" , mb:8}}>
        Stay up to date with the latest features, improvements, and fixes in
        Garuda2x. ✨
      </Typography>

      {releases.map((release, index) => (
        <Box key={index} sx={{ mt: 4 }}>
          <Typography variant="h3" gutterBottom fontWeight={600}>
            {release.timePeriod.month} {release.timePeriod.year}
          </Typography>
          <Divider />

          {release.versions.map((version, vIndex) => (
            <Box key={vIndex} sx={{ mt: 2 }}>
              <Typography variant="body2" gutterBottom fontWeight={600}>
                Version {version.version} :
              </Typography>
              {version.description && (
                <Typography className={styles.descriptionText} gutterBottom>
                  {version.description}
                </Typography>
              )}

              {version.ui && version.ui}
            </Box>
          ))}
        </Box>
      ))}

      <IFrameModal
        modalContent={modalContent}
        handleCloseModal={handleCloseModal}
        isModalOpen={isModalOpen}
      />
    </Container>
  );
};

export default ChangeLog;
